// extracted by mini-css-extract-plugin
module.exports = {"buttons":"MainRouter_buttons__36pE9"};